import MAddOnPurchasePriceWidget from "../activity/MAddOnPurchasePriceWidget";
import { Checkbox, message } from "antd";
import React, { useContext } from "react";
import MCounter from "./MCounter";
import defaultProductPic from "Images/default-brand.jpg";
import MPriceWidget2 from "Components/mobile/activity/MPriceWidget2";
import axios from "axios";
import { cartItemQtyUpdateUrl, USER_TYPE } from "Utils/constant";
import { AppContext } from "Store";
import { ICartItem } from "./MProductGroup";
import SCIcon from "Components/common/SCIcon";
import { getAuthToken } from "Utils/common";
import { gotoPdp } from "Utils/activityHelper";
import { cartTrackingDataPush } from "Utils/analyticsUtils";
export interface CartItemProps {
  cartItem: ICartItem;
  loginState: Object;
}

const CartItem: React.FC<CartItemProps> = (props: any) => {
  const { cartItem, setLoadingCart, loginState } = props;
  const { product, activityId } = cartItem;
  const isEmployee = loginState?.userType === USER_TYPE.EMPLOYEE;
  const [resetCount, setResetCount] = React.useState(0);
  const { checkedCartItems, setCheckedCartItems, refreshCartData } =
    useContext(AppContext);
  const quantityUpdating = React.useRef(false);
  const handleCartItemQtyChange = (newQty: number) => {
    if (product.purchaseType && quantityUpdating.current) return;
    quantityUpdating.current = true;
    const boundedQuantity = product.purchaseType && product.limitQty != null
      ? Math.min(newQty, product.limitQty) : newQty;
    console.log("newQty", newQty);
    setLoadingCart(true);
    axios(cartItemQtyUpdateUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getAuthToken(),
      },
      data: {
        id: cartItem.id,
        quantity: boundedQuantity,
        activityId: cartItem.activityId
      },
    }).then((res) => {
      const respData = res.data;
      if (respData.status === "success") {
        console.log("cart item qty updated");
        refreshCartData();
        const dispatchObj = {
          method: 'quantity update',
          placement: 'cart',
          products: [{
            name: product.productName,
            catalogId: product.sku,
            variant: product.productSize,
            quantity: boundedQuantity,
            price: product.finalPrice ? Number(product.finalPrice) * boundedQuantity : '0'
          }]
        };
        cartTrackingDataPush({
          cartId: cartItem.activityId,
          actionType: 'add',
          dispatchObj
        })
        return;
      }
      if (respData.status === "inventory_not_enough") {
        message.warning(
          React.createElement("div", {
            style: {
              whiteSpace: "pre-line",
            },
          }, respData.message || "该货号库存不足，暂时无法加入购物车")
        );
        refreshCartData();
        setResetCount((pre) => pre + 1);
        return;
      }
      message.error('更新失败');
      setResetCount((pre) => pre + 1);
      refreshCartData();
    }).catch(() => {
      message.error('更新失败');
      setResetCount((pre) => pre + 1);
      refreshCartData();
    }).finally(() => { quantityUpdating.current = false; });
  };
  // console.log("checkedCartItems", checkedCartItems);
  // console.log("cartItem", cartItem, checkedCartItems.has(cartItem.id));
  return (
    <div className="cartItemWrapper">
      <div className="checkboxWrapper">
        <Checkbox
          checked={checkedCartItems.has(cartItem.id)}
          onChange={(e) => {
            console.log("checkbox changed", cartItem.id);
            const checked = e.target.checked;
            if (checked) {
              checkedCartItems.add(cartItem.id);
              setCheckedCartItems(new Set(checkedCartItems));
            } else {
              checkedCartItems.delete(cartItem.id);
              setCheckedCartItems(new Set(checkedCartItems));
            }
            refreshCartData();
          }}
        ></Checkbox>
      </div>
      <div className="imgWrapper">
        <div className="productImg">
          <img
            alt=""
            src={product.productPic || defaultProductPic}
            onClick={() => {
              gotoPdp(product, loginState, 'Shopping_Cart', true, 'null', activityId);
            }}
          ></img>
        </div>
        <div className="shipIconWrapper">
          {product.deliveryChannel === "SC" && <SCIcon />}
        </div>
      </div>
      <div className="descWrapper">
        <div className="line">
          <span>{product.sku}</span>
          {product.productSize && (
            <>
              <span className="vdivider"></span>
              <span>{product.productSize}</span>
            </>
          )}
        </div>
        <div
          className={product.pdpViewable && !isEmployee ? "line1 linkable" : "line1"}
          style={{ color: isEmployee ? undefined : "#005daa" }}
          onClick={() => {
            console.log("product card clicked");
            gotoPdp(product, loginState, 'Shopping_Cart', true, 'null', activityId);
          }}
          dangerouslySetInnerHTML={{ __html: product.productName }}
        ></div>
        <div className="sideWrapper">
          {product.purchaseType ? (
          <MAddOnPurchasePriceWidget product={product} loginState={loginState} placeholder="cartItem" />
        ) : (
          <MPriceWidget2
            placeholder="cartItem"
            product={product}
            loginState={loginState}
            size="small" />
        )}
          <MCounter
            login={!!(loginState.status === "login")}
            product={product}
            value={cartItem.quantity}
            resetCount={resetCount}
          maxQuantity={product.purchaseType ? (product.limitQty ?? undefined) : undefined}
            onChange={handleCartItemQtyChange}
          />
        </div>
      </div>
    </div>
  );
};

export default CartItem;
